<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc">Contents</h2>
<p class="firstverse"><a href="#/Text/Acknowledgments">Acknowledgments</a></p>
<p class="firstverse"><a href="#/Text/Introduction">Introduction</a></p>
<p class="firstverse"><a href="#/Text/PARTONE">PART ONE<br/>
  Biblical Patterns: <span class="bi">Story-Shaped Liturgy</span></a></p>
<p class="firstverse"><a href="#/Text/SSWCh1">1: Genesis and the Gospel</a></p>
<p class="firstverse"><span href="#/Text/SSWCh2" title="Link target outside of Sample">2: Worship and Identity</span></p>
<p class="firstverse"><span href="#/Text/SSWCh3" title="Link target outside of Sample">3: Worship and Sacred Space</span></p>
<p class="firstverse"><span href="#/Text/SSWCh4" title="Link target outside of Sample">4: The Shape of Biblical Worship</span></p>
<p class="firstverse"><span href="#/Text/SSWCh5" title="Link target outside of Sample">5: Worship By The Book</span></p>
<p class="firstverse"><span href="#/Text/SSWCh6" title="Link target outside of Sample">6: Worship and Holiness</span></p>
<p class="firstverse"><span href="#/Text/SSWCh7" title="Link target outside of Sample">7: Worship in Exile, Synagogues and the Early Church</span></p>
<p class="firstverse"><span href="#/Text/PARTTWO" title="Link target outside of Sample">PART TWO<br/>
  Historical Patterns: <span class="bi">The Interpretations of Worship</span></span></p>
<p class="firstverse"><span href="#/Text/SSWCh8" title="Link target outside of Sample">8: Early Patterns for Christian Worship</span></p>
<p class="firstverse"><span href="#/Text/SSWCh9" title="Link target outside of Sample">9: Reformation Patterns for Christian Worship</span></p>
<p class="firstverse"><span href="#/Text/SSWCh10" title="Link target outside of Sample">10: Contemporary Patterns for Christian Worship</span></p>
<p class="firstverse"><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstverse"><span href="#/Text/Glossary" title="Link target outside of Sample">Glossary</span></p>
<p class="firstverse"><span href="#/Text/FurtherReading" title="Link target outside of Sample">For Further Reading</span></p>
<p class="firstverse"><span href="#/Text/SubjectIndex" title="Link target outside of Sample">Subject Index</span></p>
<p class="firstverse"><span href="#/Text/ScriptureIndex" title="Link target outside of Sample">Scripture Index</span></p>
<p class="firstverse"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
<p class="firstverse"><span href="#/Text/Endorsements" title="Link target outside of Sample">Endorsements</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1e338dc7